import { createBrowserHistory, Location } from 'history';

const history = createBrowserHistory<HistoryStateType>();

interface HistoryStateType {
  // Redirect helpers push a Location; some pages push a plain marker string
  // (e.g. 'tasksheet', 'searchIntoFees') to remember where the user came from.
  from?: Location | string;
}

export default history;
